import React, { Fragment, useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { FaFoursquare, FaPencilAlt, FaRegClock, FaRegUser, FaStarHalfAlt, FaTrashAlt } from "react-icons/fa";
import { useSelector } from "react-redux";
import { IReduxStateData } from "../../interfaces/redux";
import { PROFILE_DEALLIST } from "../../constant/menuAndProfile";

interface IDealDetail {
    // dealList: Array<any>,
    dealDetail: Array<any>,
    selectedDeal: string,
    // changeActiveDeal: (arg0: string, arg1: string) => void,
    changeDealData?: (arg0: Array<any>) => void,
    refreshData?: () => void,
    openSelectOption: (open: boolean) => void
}
export const DealList = (props: IDealDetail) => {
    let displayingDealList: any = [];
    const [isPageEdit, setIsPageEdit] = useState(false);
    const globalState = useSelector((state: IReduxStateData) => state);
    const [currentDealDetail, setCurrentDealDetail] = useState<any>({})
    const selectedLanguage = globalState?.selectedLang;
    useEffect(() => {
        if (props?.dealDetail && props?.selectedDeal) {
            props?.dealDetail?.forEach((dData: any) => {
                if (dData?.uuid === props?.selectedDeal) {
                    setCurrentDealDetail(dData)
                }
            })
        }
    }, [props?.dealDetail, props?.dealDetail.length, props?.selectedDeal])
    const calculatePercentage = (dt2: string, dt1: string) => {
        const currentDate = new Date().getTime();
        const dateTwo = new Date(dt2).getTime();
        const dateOne = new Date(dt1).getTime();
        let percentage = 0;
        if (dateOne && dateTwo && dateOne < dateTwo && dateOne < currentDate) {
            if (dateTwo > currentDate) {
                var diffCurrent = (dateTwo - currentDate) / 1000;
                diffCurrent /= (60 * 60);
                var diff = (dateTwo - dateOne) / 1000;
                diff /= (60 * 60);
                const calculatePr = Math.abs(Math.round(diffCurrent)) * 100 / Math.abs(Math.round(diff));
                percentage = 100 - calculatePr;
            } else {
                percentage = 100;
            }
        }
        return percentage;
    }
    return (
        <Fragment>
            <div className='right-side-header-main'>
                <div className='right-side-header'>{PROFILE_DEALLIST[selectedLanguage].deal_list}</div>
            </div>
            <hr />
            <Row>
                <Col sm={12} className="d-flex align-items-center align-items-center justify-content-between pl-0 pr-0">
                    {currentDealDetail?.match_title && currentDealDetail?.tp_name ?
                        <h4 className="theme-dark-black text-capitalize pl-md-4">{(currentDealDetail?.match_title ? (currentDealDetail?.match_title + " - ") : "") + (currentDealDetail?.tp_name || "")}</h4>
                        : null}
                    <div className="material-dropdown-select">
                        {/* <Dropdown>
                            <Dropdown.Toggle id="dropdown-basic">Select Stastics</Dropdown.Toggle>
                            <Dropdown.Menu>
                                {props?.dealList && props?.dealList?.map((data: any, index: number) => {
                                    // return data?.deal_list?.map((listData: any) =>
                                    //     <Dropdown.Item eventKey={index.toString()} active={data.main_deal_uuid === props.selectedDeal ? true : false} onClick={() => { props.changeActiveDeal(data.main_deal_uuid, listData?.deal_uuid) }}>{data?.match_title + "-" + listData?.tp_name}</Dropdown.Item>
                                    // )
                                    return (<Dropdown.Item eventKey={index.toString()} active={data.main_deal_uuid === props.selectedDeal?.main_deal_uuid ? true : false} onClick={() => { props.changeActiveDeal(data.main_deal_uuid, data?.deal_list[0]?.deal_uuid) }}>{data?.match_title}</Dropdown.Item>)
                                }
                                )}
                            </Dropdown.Menu>
                        </Dropdown> */}
                        <Button
                            onClick={() => { props.openSelectOption(true) }}
                            variant="primary" className='btn btn-dark theme-background-dark-black theme-white rounded-sm py-2 font-16' autoFocus>
                            {PROFILE_DEALLIST[selectedLanguage].toggle_data}
                        </Button>
                    </div >
                </Col>
            </Row>
            <Row className="right-side-wrapper">
                <Col className="blog-listing-wrapper">
                    <div className="blog-listing">
                        <Row className="blog-listing-container">
                            {props?.dealDetail && props?.dealDetail?.map((data: any, index) => {
                                if (!displayingDealList.includes(data.uuid)) {
                                    displayingDealList.push(data.uuid)
                                    return (
                                        <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                            <div className="blog-item">
                                                <div
                                                    className="blog-img position-relative h-220 background-image-css"
                                                    style={{ 'backgroundImage': `url(${data?.deal_image})` }}
                                                >
                                                    {/* <span className="blog-action-icons mt-2">
                                                        <FaPencilAlt className="mr-3 theme-white" />
                                                        <FaTrashAlt className="mr-3 theme-white" />
                                                    </span> */}
                                                    <div className="blog-content">
                                                        <h6 className="custom-test-text mb-0">
                                                            {data?.match_title}
                                                        </h6>
                                                    </div>
                                                </div>
                                                <div className="progress">
                                                    <span className="progress-value"></span>
                                                    {data?.deal_end_date && data?.deal_date ?
                                                        <div
                                                            className="progress-bar progress-bar-striped"
                                                            role="progressbar"
                                                            style={{ "width": calculatePercentage(data.deal_end_date, data.deal_date) + "%" }}
                                                        ></div>
                                                        : null
                                                    }
                                                </div>
                                                <div className="blog-content d-flex justify-content-around">
                                                    <ul className="list-unstyled mb-2 mr-4">
                                                        <li className="text-gray mb-2 d-flex">
                                                            <FaStarHalfAlt className="blog-card-icon" />
                                                            <div className="blog-card-title d-block">
                                                                <span className="d-block">{data.winner_count}</span>{PROFILE_DEALLIST[selectedLanguage].total_winner}
                                                            </div>
                                                        </li>
                                                        <li className="text-gray">
                                                            <FaRegUser className="blog-card-icon" />
                                                            {/* <i className="ti-user mr-3 "></i> */}
                                                            {/* FaRegClock */}
                                                            <div className="blog-card-title d-block">
                                                                <span className="d-block">{data.already_winner_count}</span>{PROFILE_DEALLIST[selectedLanguage].winner}
                                                            </div>
                                                        </li>
                                                    </ul>
                                                    <ul className="list-unstyled mb-2">
                                                        <li className="text-gray mb-2 d-flex">
                                                            <FaRegClock className="blog-card-icon" />
                                                            <div className="blog-card-title d-block">
                                                                <span className="d-block">{data.redeemed_count}</span>{PROFILE_DEALLIST[selectedLanguage].redeem}
                                                            </div>
                                                        </li>
                                                        <li className="text-gray d-flex">
                                                            <FaFoursquare className="blog-card-icon" />
                                                            <div className="blog-card-title d-block">
                                                                <span className="d-block">{data.total_alphcode_count}</span>{PROFILE_DEALLIST[selectedLanguage].total_user}
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </Col>
                                    )
                                } else {
                                    return (<></>)
                                }
                            })
                            }
                        </Row>
                    </div>
                </Col>
            </Row>
        </Fragment>
    );
};
